var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Redo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.75 18.75C8.23333 18.75 6.9375 18.2396 5.8625 17.2188C4.7875 16.1979 4.25 14.9417 4.25 13.45C4.25 11.9583 4.7875 10.7021 5.8625 9.68125C6.9375 8.66042 8.23333 8.15 9.75 8.15H16.175L13.5875 5.575L14.9125 4.25L19.75 9.0875L14.9125 13.925L13.5875 12.6125L16.175 10.025H9.75C8.75833 10.025 7.90625 10.3542 7.19375 11.0125C6.48125 11.6708 6.125 12.4833 6.125 13.45C6.125 14.4167 6.48125 15.2292 7.19375 15.8875C7.90625 16.5458 8.75833 16.875 9.75 16.875H16.875V18.75H9.75Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedo);
export default __webpack_public_path__ + "static/media/icon-redo.48155ceb576790db01e7f5e0b497c3cf.svg";
export { ForwardRef as ReactComponent };